import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    {/* <div className="logo">
      <span className="icon fa-cogs"></span>
    </div> */}
    <div className="content">
      <div className="inner">
        <h1>Chris Kuffert</h1>
        <p>
          Engineering Lead | Gameplay Programmer | Developer Operations Engineer
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('intro')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work0')
            }}
          >
            SOAR
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work1')
            }}
          >
            B.C.E.
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work2')
            }}
          >
            UR: The Rink
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work3')
            }}
          >
            UR: The Court
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('devops1')
            }}
          >
            DevOps and Automation
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
